/**
 * Recover a tab that outlived a deploy (custom/admin-tools).
 *
 * Every page is a separate, content-hashed script that is fetched the first
 * time the page is opened. A tab that was loaded before a deploy still asks
 * for the previous build's file names; once those are gone the page it is
 * opening never appears. Vite reports that as `vite:preloadError`, so load
 * the current build instead by reloading once.
 *
 * The timestamp guard stops a reload loop if the file is missing for some
 * other reason; without sessionStorage there is no guard, so do nothing.
 */
const STORAGE_KEY = 'spreely:stale-build-reload';
const MIN_INTERVAL_MS = 60_000;

window.addEventListener('vite:preloadError', event => {
  try {
    const last = Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
    if (Date.now() - last < MIN_INTERVAL_MS) {
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

export {};
